import type { WeekInfo } from "./useWeekManagement";

export function getWeekdayDates(
  selectedView: "PERSONAL" | "TEAM",
  selectedWeekData: WeekInfo | null,
  availableWeeks: WeekInfo[],
  lastEndedWeek: Date[]
): Date[] {
  if (selectedView === "TEAM") {
    return selectedWeekData?.weekdays || lastEndedWeek;
  }

  if (selectedWeekData && selectedWeekData.weekdays) {
    return selectedWeekData.weekdays;
  }

  if (availableWeeks.length > 0) {
    return availableWeeks[0].weekdays;
  }

  const today = new Date();
  let daysBack = 0;
  const weekdayDates: Date[] = [];

  while (weekdayDates.length < 5) {
    const date = new Date(today);
    date.setDate(date.getDate() - daysBack);
    const dayOfWeek = date.getDay();

    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      weekdayDates.push(new Date(date));
    }

    daysBack++;
    if (daysBack > 14) break;
  }

  return weekdayDates.reverse();
}
